//Proofed
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import InsightsIcon from '@mui/icons-material/Insights'
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_QUATERNARY, NAVBAR_BG } from '../theme'
import { CONTRACT_NUM, TENDER_NUM } from './common'

export const coreBasicPrice = '£690'
export const coreBasicPeriod = '/year'

export interface CoreTierFeature {
    text: string
    included: boolean
    plus?: boolean
}

export interface CoreTier {
    name: string
    price: string
    period: string
    monthlyPrice: string | null
    tagline: string
    color: string
    highlight: boolean
    badge: string | undefined
    features: CoreTierFeature[]
    cta: string
    ctaPath?: string
    compact?: boolean
}

export const coreTiers: CoreTier[] = [
    {
        name: 'Basic',
        price: coreBasicPrice,
        period: coreBasicPeriod,
        monthlyPrice: '£69',
        tagline: 'Find and monitor UK & Ireland public sector tenders',
        color: COLOR_PRIMARY,
        highlight: false,
        badge: undefined,
        features: [
            { text: 'Tailored Daily Email Alerts', included: true },
            { text: 'Flash Emails for Urgent Tenders', included: true },
            { text: 'All UK & Ireland Portals Covered', included: true },
            { text: `${TENDER_NUM} Live & Historical Tenders`, included: true },
            { text: 'Unlimited Searches', included: true },
            { text: 'CPV Code & Keyword Filtering', included: true },
            { text: 'Competitor Analysis', included: false },
            { text: 'Buyer Behaviour Analysis', included: false },
            { text: 'Tender Ninja AI Bid Writing', included: false },
            { text: 'CFP Analytics Market Intelligence', included: false },
        ],
        cta: 'Join free for 14 days',
        ctaPath: 'register',
    },
    {
        name: 'Professional',
        price: '£990',
        period: '/year',
        monthlyPrice: '£99',
        tagline: 'For Teams Serious about Growing their Public Sector Revenue',
        color: COLOR_PRIMARY,
        highlight: true,
        badge: 'Most Popular',
        features: [
            { text: 'Everything in Basic', included: true },
            { text: 'Competitor Analysis', included: true },
            { text: 'Buyer Behaviour Analysis', included: true },
            { text: 'Framework & DPS Tracker', included: true },
            { text: 'Weekly Awards Email', included: true },
            { text: 'Dedicated Account Manager', included: true },
            { text: 'Tender Ninja AI Bid Writing', included: false },
            { text: 'CFP Analytics Market Intelligence', included: false },
            // { text: 'Pipeline Forecasting', included: false },
        ],
        cta: 'Join free for 14 days',
        ctaPath: 'register',
    },
    {
        name: 'Enterprise',
        price: 'From £1,960',
        period: '/year',
        monthlyPrice: null,
        tagline: 'For organisations with multiple users and complex procurement needs',
        color: COLOR_QUATERNARY,
        highlight: false,
        badge: '3+ users',
        features: [
            { text: 'Everything in Professional', included: true },
            { text: '3+ User Licences', included: true },
            { text: 'Dedicated Training', included: true },
            { text: 'Customer Success Manager', included: true },
            { text: 'Custom Integrations', included: true },
            { text: 'SLA & Priority Support', included: true },
            { text: 'Tender Ninja AI Bid Writing', included: false },
            { text: 'CFP Analytics Market Intelligence', included: false },
            // { text: 'Pipeline Forecasting', included: true },
        ],
        cta: 'Contact Us',
    },
]


export const coreTiersRegister: CoreTier[] = [
    {
        name: 'Basic',
        price: coreBasicPrice,
        period: coreBasicPeriod,
        monthlyPrice: '£69',
        tagline: 'Find public sector tenders to grow your business',
        color: COLOR_PRIMARY,
        highlight: false,
        badge: undefined,
        features: [
            { text: 'Tailored Daily Email Alerts', included: true },
            { text: 'Flash Emails for Urgent Tenders', included: true },
            { text: 'All UK & Ireland Portals Covered', included: true },
            { text: `${TENDER_NUM} Live & Historical Tenders`, included: true },
            // { text: 'CPV Code & Keyword Filtering', included: true },
        ],
        cta: 'Choose',
        compact: true
    },
    {
        name: 'Professional',
        price: '£990',
        period: '/year',
        monthlyPrice: '£99',
        tagline: 'Build a strategy around the public sector to grow your revenue',
        color: COLOR_PRIMARY,
        highlight: true,
        badge: 'Most Popular',
        features: [
            { text: 'Competitor Analysis', included: true },
            { text: 'Buyer Behaviour Analysis', included: true },
            { text: 'Framework & DPS Tracker', included: true },
            { text: 'Weekly Awards Email', included: true },
            { text: 'Dedicated Account Manager', included: true },
            { text: 'Everything in Basic', included: true, plus: true },

        ],
        cta: 'Choose',
        compact: true
    },
]

export const pricingFaqs = [
    { q: 'Can I trial before committing?', a: 'Yes, we offer free trials in Core for 14-days with full platform access begins once registration is complete' },
    { q: 'What portals does CFP cover?', a: 'We cover Find a Tender and another 200+ portals including local authority and sector-specific portals across UK & Ireland' },
    // { q: 'Can I switch plans?', a: 'You can upgrade or downgrade your plan at any time. Changes take effect at the next billing cycle.' },
    // { q: 'Is there a contract?', a: 'All plans are billed annually with no long-term commitment beyond the year. Call 0333 772 0250 to discuss your options.' },
    { q: 'Can I add Tender Ninja or Analytics to my Core plan?', a: 'Yes, Tender Ninja can be used as a stand along product whilst CFP Analytics is best utilised alongside a Core plan. Contact us to discuss the right combination for your team.' },
    { q: 'What is included in Enterprise?', a: 'Enterprise starts from £1,960/year for 3+ users and includes full platform access, dedicated onboarding, a Customer Success Manager and custom integrations. Call us on 0333 772 0250.' },
]

export const pricingTabConfig = [
    { label: 'Core Platform', color: COLOR_PRIMARY, Icon: NotificationsActiveIcon },
    { label: 'Analytics', color: COLOR_QUATERNARY, Icon: InsightsIcon },
    { label: 'Tender Ninja', color: COLOR_SECONDARY, Icon: AutoAwesomeIcon },
]
// Tender Ninja extracts every question, drafts responses from your own knowledge, scores them against evaluation criteria and flags anything that needs strengthening before you submit
export const tenderNinjaPricing = {
    price: 'From £6,000',
    period: '/year',
    tagline: 'Safe AI bid writing using your knowledge, get a first draft in minutes',
    color: COLOR_SECONDARY,
    badge: 'Standalone',
}

export const analyticsPricing = {
    price: '£1,950',
    period: '/year',
    tagline: 'Add-on to any Core Platform plan. Full UK & Ireland public sector market intelligence.',
    color: COLOR_QUATERNARY,
    badge: 'Add-on',
}

export const HERO_TAGLINE = 'Your free 14-day trial with full platform access begins once registration is complete'
export const ENTERPRISE_CTA_COLOR = NAVBAR_BG
